module.exports = __webpack_public_path__ + "img/zlcg.45276471.png";